import { GET_AVAILABLE_COUNTERS, SET_WAIT_LIST_ID } from './actionTypes';

import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';

import { receiveError } from './notificationAction';
import queueRemote from '../../api/queueRemote';


function setWaitListId(waitListId: number) {
  return {
    type: SET_WAIT_LIST_ID,
    data: waitListId
  }
}

function removeWaitList(waitListId: number) {

  return (dispatch: any) => {

    queueRemote.callDriver(waitListId, 'check_in').then((res: ApiResponse<boolean>) => {
      const result: any | undefined = res.success;
      const error: ResponseError | undefined = res.error;

      if (result) {
        dispatch(setWaitListId(0));
      }

      if (error) {
        dispatch(receiveError(error));
      }
    });
  };
}

export {
  removeWaitList,
  setWaitListId
}